<!-- This wrapper is the SHARED ELEMENT -->
<div
  class="care-pathway-stepper-grid care-pathway-stepper-grid--{{
    steps.length
  }}"
  [class.care-pathway-stepper-grid--minimal]="variant === 'in-step'"
  style="view-transition-name: stepper"
>
  @for (s of steps; track s.name + s.subtitle; let i = $index) {
  <button
    class="step"
    (click)="onClick(i)"
    [class.no-text]="variant === 'in-step'"
  >
    <div
      class="icon-container"
      [class.icon-container--inactive]="
        variant === 'in-step' && i !== selectedIndex
      "
    >
      @if(variant === 'in-step') { @if(i === selectedIndex) {
      <mat-icon fontSet="material-symbols-outlined">{{ s.icon }}</mat-icon>
      } @if(i !== selectedIndex) {
      <span class="step-index">{{ i + 1 }}</span>
      } } @if(variant === "global") {
      <mat-icon fontSet="material-symbols-outlined">{{ s.icon }}</mat-icon>
      }
    </div>

    @if(variant === "global") {
    <span class="title">{{ s.name }}</span>
    <span class="subtitle">{{ s.subtitle }}</span>
    } @if (i !== 0) {
    <span
      class="path-connector path-connector--before"
      [class.path-connector--active]="selectedIndex === i"
    ></span>
    } @if(i !== steps.length - 1) {
    <span
      class="path-connector path-connector--after"
      [class.path-connector--active]="selectedIndex === i"
    ></span>
    }
  </button>
  }
</div>
